import React from 'react';
import { Avatar, Box, Grid, makeStyles, Typography } from '@material-ui/core';
import propTypes from 'prop-types';

const useStyles = makeStyles((theme) => ({
  header: {
    background: 'rgb(251, 251, 251)',
    display: 'flex',
    flexWrap: 'nowrap',
  },
  img: {
    height: '50px',
    width: '50px',
    margin: '16px',
    marginRight: '8px',
  },
  title: {
    fontSize: '.8rem',
    fontWeight: 'bold',
  },
  subtitle: {
    fontSize: '0.8rem',
    fontWeight: '300',
    opacity: '0.7',
  },
}));

function Header(props) {
  const classes = useStyles();
  return (
    <Grid alignItems="center" className={classes.header} container>
      <Grid item>
        <Avatar className={classes.img} src={props.image} />
      </Grid>
      <Box direction="column">
        <Typography className={classes.title} variant="h1">
          {props.organization}
        </Typography>
        <Typography className={classes.subtitle} variant="subtitle1">
          Asistente Virtual
        </Typography>
      </Box>
    </Grid>
  );
}

const Props = {
  organization: propTypes.string.isRequired,
  image: propTypes.string,
};

Header.propTypes = Props;

export default Header;
